module.exports = __webpack_public_path__ + "img/07.7d3819d3.jpg";